import { removeProtectionLink } from './removeProtection.locstring.json';
import loc from 'owa-localize';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import { ComposeViewState } from 'owa-mail-compose-store';
import setIRMData from '../actions/setIRMData';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function removeProtection(
    viewState: ComposeViewState,
    templateId: string
): InfoBarCustomAction {
    return {
        text: loc(removeProtectionLink),
        action: () => {
            removeInfoBarMessage(viewState, templateId);
            setIRMData(viewState, null);
        },
    };
}
